// ================================================================
// SHARED FUNCTIONS - Módulo Operacional
// Funções compartilhadas entre dashboard, diário e prescrições
// ================================================================

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.operacional = window.FazendaRP.Pages.operacional || {};

window.FazendaRP.Pages.operacional.shared = {
    // ===== STATE =====
    variedadesCache: [],
    maquinasCache: [],
    stockCache: null,
    insumosCache: null,
    safraAtual: '25/26', // Safra padrão
    safraOptionsHtml: '',

    // ===== VARIEDADES MANAGEMENT =====
    loadVariedades: async function (safraAno = null) {
        try {
            console.log('🔍 INICIANDO loadVariedades...');
            console.log('🔍 Safra solicitada:', safraAno || 'Auto (mais recente)');

            let safra = null;

            // 1. Se uma safra específica foi solicitada, buscar por ano
            if (safraAno) {
                const { data: safraData, error: safraError } = await window.FazendaRP.supabase
                    .from('safras')
                    .select('id, cultura, area_plantada, ano')
                    .eq('ano', safraAno)
                    .limit(1);

                if (safraError) {
                    console.error('❌ Erro ao buscar safra específica:', safraError);
                    throw safraError;
                }

                if (safraData && safraData.length > 0) {
                    safra = safraData[0];
                    console.log(`✅ Safra específica encontrada: ${safra.ano} (ID: ${safra.id})`);
                }
            }

            // 2. Se não encontrou ou não foi especificada, buscar a mais recente
            if (!safra) {
                const { data: safras, error: safrasError } = await window.FazendaRP.supabase
                    .from('safras')
                    .select('id, cultura, area_plantada, ano')
                    .order('created_at', { ascending: false })
                    .limit(1);

                console.log('🔍 Safras encontradas:', safras);
                if (safrasError) {
                    console.error('❌ Erro ao buscar safras:', safrasError);
                    throw safrasError;
                }

                if (!safras || safras.length === 0) {
                    console.warn('⚠️ Nenhuma safra encontrada!');
                    this.variedadesCache = [];
                    return [];
                }

                safra = safras[0];
                console.log(`✅ Usando safra mais recente: ${safra.ano} (ID: ${safra.id})`);
            }

            this.safraAtual = safra.ano;

            // 3. Buscar variedades dessa safra
            const { data, error } = await window.FazendaRP.supabase
                .from('safras_areas')
                .select('*, variedades_catalogo(nome, cultura, ciclo, ciclo_dias)')
                .eq('safra_id', safra.id);

            console.log('🔍 safras_areas raw data:', data);
            console.log('🔍 safras_areas error:', error);

            if (error) {
                console.error('❌ Erro ao buscar safras_areas:', error);
                throw error;
            }

            // 4. Transformar dados
            this.variedadesCache = (data || []).map(v => {
                const nome = v.variedades_catalogo ? v.variedades_catalogo.nome : (v.variedade_nome_temp || `Variedade ${v.id}`);
                const cultura = v.variedades_catalogo ? v.variedades_catalogo.cultura : (safra.cultura || 'N/A');

                return {
                    id: v.id,
                    nome: nome,
                    area_hectares: v.area_ha,
                    cultura_atual: cultura,
                    safra: safra.ano,
                    variedade_id: v.variedade_id,
                    ciclo: v.variedades_catalogo?.ciclo || 'N/A',
                    ciclo_dias: v.variedades_catalogo?.ciclo_dias || 120
                };
            }).sort((a, b) => a.nome.localeCompare(b.nome));

            console.log(`✅ SUCESSO! Carregadas ${this.variedadesCache.length} variedades da safra ${safra.ano}`);
            console.log('📋 Variedades:', this.variedadesCache);

            return this.variedadesCache;

        } catch (err) {
            console.error('💥 ERRO FATAL em loadVariedades:', err);
            this.variedadesCache = [];
            return [];
        }
    },

    // ===== SAFRAS MANAGEMENT =====
    populateSafras: async function () {
        try {
            const { data, error } = await window.FazendaRP.supabase
                .from('safras')
                .select('ano, cultura')
                .order('created_at', { ascending: false });

            if (data) {
                const uniqueSafras = Array.from(new Set(data.map(s => s.ano)));

                const options = uniqueSafras.map(ano => {
                    const isSelected = ano === this.safraAtual ? 'selected' : '';
                    return `<option value="${ano}" ${isSelected} style="color:#1f2937; background:white;">${ano}</option>`;
                }).join('');

                this.safraOptionsHtml = options;
                return options;
            }
        } catch (e) {
            console.error('Error populating safras', e);
        }
        return '';
    },

    handleSafraChange: function (newSafra, callback) {
        if (newSafra && newSafra !== this.safraAtual) {
            this.safraAtual = newSafra;
            this.variedadesCache = [];

            if (callback && typeof callback === 'function') {
                callback(newSafra);
            }
        }
    },

    // ===== MÁQUINAS MANAGEMENT =====
    loadMaquinas: async function () {
        if (this.maquinasCache && this.maquinasCache.length > 0) return this.maquinasCache;

        try {
            const { data, error } = await window.FazendaRP.supabase
                .from('frota')
                .select('id, nome, modelo')
                .in('status', ['Ativo', 'ativo']);

            if (error) throw error;
            this.maquinasCache = data || [];
            return this.maquinasCache;
        } catch (e) {
            console.error('Error loading machines:', e);
            this.maquinasCache = [];
            return [];
        }
    },

    // ===== STOCK/INSUMOS MANAGEMENT =====
    loadStockCache: async function () {
        if (this.stockCache) return this.stockCache;

        try {
            const { data } = await window.FazendaRP.supabase
                .from('suprimentos_estoque')
                .select('id, item_nome, custo_medio, unidade');

            this.stockCache = data || [];
            return this.stockCache;
        } catch (e) {
            console.error('Error loading stock:', e);
            return [];
        }
    },

    // ===== INSUMOS MANAGEMENT =====
    loadInsumos: async function () {
        // Always reload to ensure fresh data (or we can keep cache if already populated)
        // if (this.insumosCache && this.insumosCache.length > 0) return this.insumosCache;

        try {
            console.log("🔄 Loading Insumos (Catalog + Stock)...");

            // 1. Fetch Catalog (Itens) - Schema Checked: id, nome, tipo, unidades, status
            const { data: itens, error: errItens } = await window.FazendaRP.supabase
                .from('suprimentos_itens')
                .select('id, nome, unidades, tipo')
                .eq('status', 'Ativo')
                .order('nome');

            if (errItens) throw errItens;

            // 2. Fetch Stock (Estoque) for costs
            const { data: stock, error: errStock } = await window.FazendaRP.supabase
                .from('suprimentos_estoque')
                .select('id, item_nome, custo_medio, unidade');

            if (errStock) console.warn("Error loading stock for costs:", errStock);

            // 3. Merge Strategies
            const catalog = itens || [];
            const stockItems = stock || [];

            this.insumosCache = catalog.map(i => {
                const st = stockItems.find(s => s.item_nome === i.nome);
                // Handle unidades array (take first or join)
                const unitDisplay = Array.isArray(i.unidades) ? i.unidades[0] : (i.unidades || '');

                return {
                    id: i.id,
                    nome: i.nome,
                    unidade: unitDisplay, // Normalized to single string
                    categoria: i.tipo,    // Mapped from 'tipo'
                    custo_medio: st ? st.custo_medio : 0,
                    source: 'catalog'
                };
            });

            // 4. Add Orphans (Items in stock but not in active catalog)
            stockItems.forEach(s => {
                if (!this.insumosCache.find(c => c.nome === s.item_nome)) {
                    this.insumosCache.push({
                        id: s.id, // Use stock ID as fallback? Or generated?
                        nome: s.item_nome,
                        unidade: s.unidade,
                        categoria: 'Estoque (Legado)',
                        custo_medio: s.custo_medio,
                        source: 'stock_orphan'
                    });
                }
            });

            // Sort by name
            this.insumosCache.sort((a, b) => a.nome.localeCompare(b.nome));

            console.log(`✅ Insumos Loaded: ${this.insumosCache.length} items.`);
            return this.insumosCache;

        } catch (e) {
            console.error('Error loading insumos:', e);
            this.insumosCache = [];
            return [];
        }
    },

    // ===== FINANCIAL DATA =====
    fetchFinancialData: async function () {
        try {
            const { data: activities } = await window.FazendaRP.supabase
                .from('operacional_atividades')
                .select('variedades_ids, insumos');

            if (!activities) return {};

            const costMap = {};

            activities.forEach(act => {
                if (act.insumos && Array.isArray(act.insumos)) {
                    let actCost = 0;
                    act.insumos.forEach(i => {
                        if (i.total > 0) {
                            const unitCost = parseFloat(i.custo) || 0;
                            actCost += (parseFloat(i.total) || 0) * unitCost;
                        }
                    });

                    if (act.variedades_ids && Array.isArray(act.variedades_ids)) {
                        const share = actCost / act.variedades_ids.length;
                        act.variedades_ids.forEach(vid => {
                            costMap[vid] = (costMap[vid] || 0) + share;
                        });
                    }
                }
            });
            return costMap;

        } catch (e) {
            console.error("Financial data error:", e);
            return {};
        }
    },

    // ===== UTILITY FUNCTIONS =====
    formatCurrency: function (value) {
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },

    formatDate: function (dateStr) {
        return new Date(dateStr).toLocaleDateString('pt-BR');
    },

    formatDateRange: function (startDate, endDate) {
        const start = new Date(startDate).toLocaleDateString('pt-BR');
        if (!endDate || endDate === startDate) return start;
        const end = new Date(endDate).toLocaleDateString('pt-BR');
        return `${start} - ${end}`;
    },

    calculateDAP: function (plantingDate) {
        const today = new Date();
        const planting = new Date(plantingDate);
        const diffTime = Math.abs(today - planting);
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    },

    // ===== COST CALCULATION =====
    /**
     * Busca preço de um insumo (estoque ou última compra)
     * @param {string} nomeInsumo - Nome do insumo
     * @returns {Promise<number>} - Preço em R$/unidade
     */
    getItemPrice: async function (nomeInsumo) {
        try {
            // 1. Tentar do estoque
            const { data: stockData } = await window.FazendaRP.supabase
                .from('suprimentos_estoque')
                .select('preco_medio')
                .ilike('item_nome', `%${nomeInsumo}%`)
                .limit(1)
                .single();

            if (stockData && stockData.preco_medio > 0) {
                return parseFloat(stockData.preco_medio);
            }

            // 2. Tentar da última compra (movimentações de entrada)
            const { data: movData } = await window.FazendaRP.supabase
                .from('suprimentos_movimentacoes')
                .select('valor_total, quantidade')
                .ilike('item_nome', `%${nomeInsumo}%`)
                .eq('tipo', 'Entrada')
                .not('valor_total', 'is', null)
                .gt('quantidade', 0)
                .order('data', { ascending: false })
                .limit(1)
                .single();

            if (movData && movData.valor_total && movData.quantidade) {
                return parseFloat(movData.valor_total) / parseFloat(movData.quantidade);
            }

            // 3. Não encontrado
            return 0;

        } catch (err) {
            console.warn(`Preço não encontrado para: ${nomeInsumo}`, err);
            return 0;
        }
    },

    /**
     * Calcula custo estimado de uma prescrição
     * @param {Array} insumos - [{item, dose, unidade}]
     * @param {number} areaTotal - Área em hectares
     * @returns {Promise<number>} - Custo total estimado
     */
    calculatePrescriptionCost: async function (insumos, areaTotal) {
        if (!insumos || insumos.length === 0 || !areaTotal) return 0;

        let total = 0;

        for (const insumo of insumos) {
            const preco = await this.getItemPrice(insumo.item);
            const quantidadeTotal = parseFloat(insumo.dose) * parseFloat(areaTotal);
            total += quantidadeTotal * preco;
        }

        return total;
    }
};
